import { z } from 'zod';

export interface AuditEntry {
  readonly id: string;
  readonly actorId: string | null;
  readonly actorName: string | null;
  readonly action: string;
  readonly targetType: string;
  readonly targetId: string | null;
  readonly detail: Record<string, unknown>;
  readonly createdAt: string;
}

const rowSchema = z.object({
  id: z.string(),
  actor_id: z.string().nullable(),
  action: z.string(),
  target_type: z.string(),
  target_id: z.string().nullable(),
  detail: z.record(z.unknown()).default({}),
  created_at: z.string(),
  actor: z.object({ full_name: z.string() }).nullable().optional(),
});

export function mapAuditEntry(row: unknown): AuditEntry {
  const r = rowSchema.parse(row);
  return {
    id: r.id,
    actorId: r.actor_id,
    actorName: r.actor?.full_name ?? null,
    action: r.action,
    targetType: r.target_type,
    targetId: r.target_id,
    detail: r.detail,
    createdAt: r.created_at,
  };
}
